const Footer = () => {
  return (
    <div class="mt-16 mb-8 relative overflow-hidden w-full">
      <p className="text-lg text-center text-[#9CA3AF] tracking-wider">
        Site is still under development
      </p>
      <p className="mt-8 text-lg text-center text-[#ffffff] tracking-wider">
        Based in India ❤️
      </p>
    </div>
  );
};
export default Footer;
